import { EMAIL_MASK_INPUT_LIMIT, EMAIL_MASK_TRUNCATION, guvenliKesim } from './email-mask-kesim';
import { NORMALIZASYON_ADIMLARI, normalizeForMasking, } from './email-mask-normalize';
import { ATIL_MADDELER, YAPISAL_VARSAYILAN, adresDeseni, } from './email-mask-structure';
/**
 * SAĞLAYICI METNİNDEN ADRES MASKELEME — TEK KAYNAK.
 *
 * `email_deliveries` tablosu bilinçli olarak GÖVDE ve DÜZ ADRES saklamaz
 * (OTP kodu + KVKK); alıcı yalnız `to_email_hash` olarak durur. TEK sızıntı
 * yüzeyi `last_error`dır: metni biz yazmayız, SMTP sağlayıcısı yazar ve
 * sağlayıcı tipik olarak reddettiği adresi yanıtın içine koyar
 * (`550 5.1.1 <ali@ornek.com>: Recipient address rejected`).
 *
 * Yani satırın kendisi adres taşımasa da hata metni taşır. Maskeleme bu yüzden
 * SUNUCUDA, veri istemciye çıkmadan önce uygulanır: panelin ekranında
 * "gösterme" kararı vermek yetmez — adres tarayıcının ağ sekmesine, önbelleğine
 * ve hata raporlayıcısına yine düşerdi.
 *
 * YÖN FAIL-CLOSED: şüpheli her dizge maskelenir. Fazla maskelemek bir teşhis
 * ayrıntısını kaybettirir; eksik maskelemek kişisel veri sızdırır.
 *
 * ---------------------------------------------------------------------------
 * YÖNTEM DEĞİŞTİ (16.09.2026, QA üçüncü dalga): LİSTE BÜYÜTMEK ÇALIŞMADI.
 *
 * Desen üç turda üç kez genişletildi (geliştirici 2 · tech-lead 8 · QA 8 yeni
 * kaçamak) ve her turda yeni bir KODLAMA BİÇİMİ kaçtı: çok satırlı SMTP yanıtı,
 * çift yüzde kodlaması, HTML varlığı, quoted-printable, sıfır genişlikli
 * boşluk, yumuşak tire, NBSP, tam genişlikli nokta. Ortak kök tekti: desen
 * "adresin kaç farklı yazımı var" sorusunu cevaplamaya çalışıyordu ve o soru
 * SONSUZ. Kaçış biçimleri birleştirilebilir olduğu için liste asla kapanmaz.
 *
 * BEŞİNCİ DALGA VE İKİNCİ YÖNTEM DEĞİŞİKLİĞİ (16.09.2026, QA dördüncü turu):
 * NORMALLEŞTİRME DE BİR ÇÖZÜCÜ LİSTESİYDİ. QA yirmi dakikada sekiz biçim daha
 * buldu ve DÖRDÜ panelde GÖZLE okunuyordu — üstelik hiçbirinin kodlamayla
 * ilgisi yoktu: `ali<!---->@ornek.com`, `<span>ali</span>@ornek.com`,
 * `<ali@(yorum)ornek.com>`, `ali at ornek dot com`. Kök tekti: desen `@`nin
 * İKİ YANINI BİTİŞİK görmek zorundaydı. Bitişiklik şartı bu turda kalktı —
 * bkz. `email-mask-structure.ts` (yapısal indirgeme). Normalleştirme duruyor
 * ve gerekli; ama artık TEK ayak değil.
 *
 * Bugünkü yöntem: EŞLEŞMEDEN ÖNCE NORMALLEŞTİR. Metin tek bir kanonik biçime
 * indirgenir (katlama açılır · kodlamalar sabit noktaya kadar çözülür ·
 * görünmez karakterler sökülür · NFKC uygulanır), desen yalnız o kanonik
 * biçimi tanır. `＠`, `．`, `%40`, `&#64;`, `=40`, `@` gibi biçimlerin
 * DESENDE karşılığı YOKTUR ve olmasına gerek yoktur — normalleştirme onları
 * `@` ve `.` yapar. Yeni bir kodlama biçimi çıkarsa çözüm listesine TEK satır
 * eklenir; desen büyümez.
 *
 * YEDİNCİ DALGA — YÖN TERSİNE DÖNMÜŞTÜ (QA, 16.09.2026). ÖLÇÜLDÜ: `atillariSok`
 * atıl maddenin İÇİNDEKİ HER ŞEYİ siliyordu ve adres atıl maddenin İÇİNDEYSE
 * (sağlayıcının HTML/XML gövdesinde bu KURAL, istisna değil) adres de siliniyor,
 * kanonik biçimde eşleşme kalmıyor, `maskeli === kanonik` oluyor ve fonksiyon
 * ÖZGÜN dizeyi HAM döndürüyordu. On yük panelde GÖZLE okundu. Yani "şüpheli her
 * dizge maskelenir" beyanının tersi oluyordu: metin ne kadar çok etiket/yorum/
 * CDATA taşırsa maskelemeden kaçma olasılığı o kadar ARTIYORDU.
 *
 * KÖK, LİSTE DEĞİL GÜVEN İLİŞKİSİYDİ: bilgi YOK EDEN bir adımın ardından
 * "bulamadım" sonucuna TEK BAŞINA güvenmek. Listeye satır eklemek (yeni etiket
 * biçimi, yeni bildirim) sekizinci dalgayı doğururdu.
 *
 * ÇÖZÜM: ÇOK GÖRÜNÜMLÜ MASKELEME (bkz. `MASKE_GORUNUMLERI`). Aynı metin BİRDEN
 * ÇOK görünümde taranır ve sonuçlar BİRİKTİRİLİR; hiçbir görünümün "eşleşme
 * yok" sonucu tek başına bağlayıcı değildir. Listenin SONUNCUSU KAYIPSIZDIR
 * (ham metnin kendisi) ve bunu TİP şart koşar, yani `return value` dalı artık
 * yalnız kayıplı bir dönüşümün sözüne dayanmaz.
 *
 * SEKİZİNCİ DALGA — GÖRÜNÜMLER ARTIK ELLE YAZILMIYOR (tech-lead, 16.09.2026).
 * Yedinci dalganın üç görünümü bir LİSTEYDİ ve liste sınıfı kapatmadı: iki atıl
 * tür İÇ İÇE geçtiğinde (bir HTML yorumunun içindeki etiket — yani sıradan bir
 * hata gövdesi) doğru okuma İKİSİNİN KARIŞIMIDIR. Ölçüldü: dokuz bileşimin
 * SEKİZİ sızdı, üçünde adres bütünüyle ham kaldı. Görünümler bu yüzden
 * `ATIL_MADDELER`den ÜRETİLİR (tüm altkümeler × iki ayırma kipi); dördüncü bir
 * görünüm "nereye girer" sorusu ortadan kalkar, çünkü elle giren yoktur.
 *
 * ÇIKTI KARARI — NORMALLEŞTİRİLMİŞ METİN DÖNER, İNDEKS HARİTASI YOK.
 * Maskeleme normalleştirilmiş metne uygulanır ve eşleşme bulunursa çıktı O
 * metindir; özgün dizeye geri yansıtma (indeks haritası) YAPILMAZ. Gerekçe:
 * her çözüm adımı uzunluğu değiştirir, haritanın bir karakterlik kayması
 * adresin bir parçasını HAM bırakır — yani karmaşıklık doğrudan sızıntıya
 * dönüşür. `lastError` yalnız TANI amaçlı gösterim metnidir (sözleşmede arama
 * ya da eşleştirme için kullanılmaz), birebir korunması gerekmez.
 * EŞLEŞME YOKSA ÖZGÜN DİZE AYNEN DÖNER: adressiz hata metinleri — çoğunluk —
 * normalleştirmeden hiç etkilenmez, teşhis ayrıntısı bozulmaz. HAM GÖRÜNÜM
 * ÖNCE KOŞTUĞU İÇİN teşhis metni ARTIK DAHA AZ BOZULUR: adres ham metinde
 * okunabiliyorsa (yaygın hâl) yalnız o parça değişir, `<LF>` gibi yer
 * tutucular ve HTML sarmalayıcılar yerinde kalır.
 */
/** Maskelenmiş adresin yerine geçen sabit işaret. Panelde aynen görünür. */
export const EMAIL_MASK = '[eposta]';
/* ==========================================================================
 * GİRDİ TAVANI VE GÜVENLİ KESİM — AYRI DOSYADA (`email-mask-kesim.ts`).
 * Kamuya açık yüzey burada kalır; çağıranlar `./email-mask` import eder.
 * ========================================================================== */
export { EMAIL_MASK_INPUT_LIMIT, EMAIL_MASK_SOURCE_CEILING, EMAIL_MASK_TRUNCATION, } from './email-mask-kesim';
/* ==========================================================================
 * NORMALLEŞTİRME — AYRI DOSYADA (`email-mask-normalize.ts`).
 *
 * Adımlar dizi olarak DIŞARI AÇILIR: `email-mask.spec.ts` her adımı tek tek
 * SÖKER ve o adım olmadan hangi biçimin sızdığını ölçer (mutasyon probu).
 * Kamuya açık yüzey burada kalır — çağıranlar `./email-mask` import eder.
 * ========================================================================== */
export { NORMALIZASYON_ADIMLARI, NORMALIZASYON_TAVANI, normalizeForMasking, } from './email-mask-normalize';
export { KOD_COZUM_TAVANI, kodlamalariCoz } from './email-mask-decoders';
/* ==========================================================================
 * 5. EŞLEŞTİR — KANONİK BİÇİM ÜZERİNDE, YAPISAL PARÇALARLA.
 *
 * Desenin parçaları (`YEREL` · `AT` · `ALAN` · atıl ara) artık burada değil
 * `email-mask-structure.ts`tedir ve BİTİŞİKLİK ŞARTI KALKMIŞTIR. Bu dosyanın
 * işi "ne döneriz" kararıdır: normalleştir, eşleştir, eşleşme yoksa özgün
 * dizeyi aynen ver.
 * ========================================================================== */
const EMAIL_IN_TEXT = adresDeseni();
export function maskEmails(value) {
    if (typeof value !== 'string')
        return value;
    return maskEmailsWith(value, NORMALIZASYON_ADIMLARI);
}
/** Her adımın SEÇİMLİ ikizini `ayrilan` kümesi ve KİPLE sürer; ikizi olmayan aynen kalır. */
function gorunumAdimlari(adimlar, ayrilan, kip) {
    return adimlar.map((adim) => adim.secimli
        ? { ad: adim.ad, uygula: (metin) => adim.secimli(metin, ayrilan, kip) }
        : adim);
}
/**
 * GÖRÜNÜM SEÇİMLERİ — `ATIL_MADDELER`in tüm altkümeleri × İKİ AYIRMA KİPİ.
 *
 * Sıra: önce ayrılan madde SAYISI (indirgeme gücü azalan yön), aynı sayıda
 * `secici` önce (içeriğe bakıp gürültüyü söktüğü için daha güçlü indirger).
 */
function gorunumSecimleri() {
    const adlar = ATIL_MADDELER.map((madde) => madde.ad);
    const secimler = [];
    for (let maske = 0; maske < 1 << adlar.length; maske += 1) {
        const ayrilan = new Set(adlar.filter((_, sira) => (maske >> sira) & 1));
        // ∅ ucunda kip ANLAMSIZDIR (açılacak madde yok): tek görünüm, `kanonik`.
        if (ayrilan.size > 0)
            secimler.push({ ayrilan, kip: 'secici' });
        secimler.push({ ayrilan, kip: 'ayir' });
    }
    return secimler.sort((a, b) => a.ayrilan.size - b.ayrilan.size || (a.kip === b.kip ? 0 : a.kip === 'secici' ? -1 : 1));
}
/**
 * Seçim → görünüm adı. İKİ UÇ TARİHÎ ADINI KORUR (`kanonik`, `atil-korunmus`):
 * kapılar ve yük tabloları o adlarla yazılmıştır.
 */
function gorunumAdi({ ayrilan, kip }) {
    if (ayrilan.size === 0)
        return 'kanonik';
    const govde = ayrilan.size === ATIL_MADDELER.length ? 'hepsi' : [...ayrilan].join('+');
    const taban = kip === 'ayir' ? 'atil-korunmus' : 'atil-secici';
    return govde === 'hepsi' && kip === 'ayir' ? 'atil-korunmus' : `${taban}:${govde}`;
}
const HAM_GORUNUM = { ad: 'ham', kayipsiz: true, hazirla: (metin) => metin };
export const MASKE_GORUNUMLERI = [
    ...gorunumSecimleri().map((secim) => ({
        ad: gorunumAdi(secim),
        kayipsiz: false,
        hazirla: (metin, adimlar) => normalizeForMasking(metin, gorunumAdimlari(adimlar, secim.ayrilan, secim.kip)),
    })),
    HAM_GORUNUM,
];
/**
 * Maskelemeyi VERİLEN adım kümesi ve VERİLEN yapısal ayarla koşar. Üretimde tek
 * çağıran `maskEmails`; dışarı açık olmasının sebebi mutasyon probudur
 * (md. 3d/3): kapı, adımları ve yapısal ayakları tek tek sökerek her birinin
 * GERÇEKTEN taşıdığı yükü ölçer.
 */
export function maskEmailsWith(value, adimlar, ayar = YAPISAL_VARSAYILAN, gorunumler = MASKE_GORUNUMLERI) {
    if (value.length > EMAIL_MASK_INPUT_LIMIT) {
        // Kuyruk KESİLİR (bkz. `EMAIL_MASK_INPUT_LIMIT`): taranmamış metin dönmez.
        const bas = maskEmailsWith(guvenliKesim(value), adimlar, ayar, gorunumler);
        return `${bas}${EMAIL_MASK_TRUNCATION}`;
    }
    const desen = ayar === YAPISAL_VARSAYILAN ? EMAIL_IN_TEXT : adresDeseni(ayar);
    /*
     * GÖRÜNÜMLER BİRİKTİRİR: her görünüm bir öncekinin ÇIKTISINI tarar ve yalnız
     * YENİ eşleşme bulduğunda sonucu değiştirir. Hiçbir görünümün "eşleşme yok"
     * sonucu tek başına `value` döndürmez — `sonuc` yalnız HEPSİ bulamadığında
     * özgün dizeye eşit kalır ve listenin SONUNCUSU (tip gereği) KAYIPSIZDIR.
     *
     * AYNI METNİ ÜRETEN GÖRÜNÜM İKİ KEZ TARANMAZ: eşleşme maliyetin tamamıdır
     * (ölçüm başlıkta) ve atıl madde taşımayan metinde bütün altkümeler aynı
     * metne iner. Tekleştirme bir KISAYOL DEĞİLDİR — "burada adres olamaz"
     * varsayımı yapmaz, yalnız AYNI dizgeyi aynı desenle iki kez taramaz.
     */
    const taranan = new Set();
    return gorunumler.reduce((sonuc, gorunum) => {
        const okunus = gorunum.hazirla(sonuc, adimlar);
        if (taranan.has(okunus))
            return sonuc;
        taranan.add(okunus);
        desen.lastIndex = 0;
        const maskeli = okunus.replace(desen, EMAIL_MASK);
        return maskeli === okunus ? sonuc : maskeli;
    }, value);
}
/** Maskelemenin gerçekten çalıştığını çağıran tarafta da ölçebilmek için. */
export function containsEmail(value) {
    if (typeof value !== 'string')
        return false;
    /*
     * ÖLÇÜ ARACI DA ÇOK GÖRÜNÜMLÜDÜR — YOKSA KÖR KALIR (QA P1-2, 16.09.2026).
     *
     * Eski hâli YALNIZ kanonik görünüme bakıyordu, yani `maskEmails`in kaçırdığı
     * kusuru TANIM GEREĞİ göremiyordu: QA'nın on yükünün onunda da `false`
     * dönüyordu. Üç yüzey kapısı (birim · panel DOM'u · api e2e) aynı gözle
     * ölçtüğü için üçü birden yeşil kalmıştı — kapı yeşilken kusur canlıydı.
     * Bundan beteri yoktu: korpusun 1. AYAĞI `containsEmail(metin) === true`
     * şartı koştuğu için o on vaka korpusa EKLENEMİYORDU bile.
     *
     * `maskEmails` neyi tarıyorsa bu da onu tarar: aynı girdi tavanı, aynı
     * güvenli kesim, AYNI GÖRÜNÜM LİSTESİ. İkisi ayrışırsa "maskeledim" ile
     * "adres kalmadı" farklı şeyleri ölçmeye başlar.
     */
    const sinirli = value.length > EMAIL_MASK_INPUT_LIMIT ? guvenliKesim(value) : value;
    const taranan = new Set();
    return MASKE_GORUNUMLERI.some((gorunum) => {
        const okunus = gorunum.hazirla(sinirli, NORMALIZASYON_ADIMLARI);
        if (taranan.has(okunus))
            return false;
        taranan.add(okunus);
        EMAIL_IN_TEXT.lastIndex = 0;
        return EMAIL_IN_TEXT.test(okunus);
    });
}
/**
 * Alıcı hash'inin EKRANA ÇIKAN parçası.
 *
 * Ham sha256 istemciye HİÇ GİTMEZ. Gerekçe ölçülebilir: e-posta adresinin
 * sha256'sı tersine çevrilemez değildir — adres uzayı küçüktür ve bilinen bir
 * liste üzerinden kaba kuvvet saniyeler sürer. 64 karakterin tamamını tarayıcıya
 * göndermek, "adres saklamıyoruz" kararını fiilen geri alırdı. 8 onaltılık
 * karakter (32 bit) destek talebiyle satırı eşleştirmeye yeter, kimlik
 * çözmeye yetmez.
 */
export const EMAIL_HASH_PREFIX_LENGTH = 8;
export function emailHashPrefix(hash) {
    return hash.slice(0, EMAIL_HASH_PREFIX_LENGTH);
}
//# sourceMappingURL=email-mask.js.map